import {Button, Checkbox, Col, Row} from 'antd';
import {CheckboxChangeEvent} from 'antd/lib/checkbox';
import React from 'react';
import {Mutation} from 'react-apollo';
import {UPDATE_ORDER_TESTING_FLAG} from '../../../../../../graphql';
import {Order} from '../../../../../../interfaces';
import HistoryDetail from './components/History';
import PaymentDetail from './components/Payment';
import PersonalDetail from './components/Personal';
import PriceList from './components/Prices';
import './styles.css';

interface Properties {
  orderData: Order;
  index: number;
}

class Detail extends React.PureComponent<Properties> {
  updateIsTestingFlag = (mutation: any) => (e: CheckboxChangeEvent) => {
    const isTesting = e.target.checked;
    mutation({variables: {isTesting}});
  };

  render() {
    const {orderData} = this.props;
    return (
      <Mutation mutation={UPDATE_ORDER_TESTING_FLAG} variables={{reference: orderData.reference}}>
        {(updateOrder: any) => (
          <div className="generalInfo">
            <Row gutter={16}>
              <Col style={{marginBottom: 16}} xs={24} lg={12} xl={8}>
                <PersonalDetail orderData={orderData} />
              </Col>
              <Col style={{marginBottom: 16}} xs={24} lg={12} xl={8}>
                <PaymentDetail orderData={orderData} />
              </Col>
              <Col style={{marginBottom: 16}} xs={24} lg={24} xl={8}>
                <HistoryDetail orderData={orderData} />
              </Col>
            </Row>
            <div className="breakLine" />
            <Row>
              <PriceList orderData={orderData} />
            </Row>
            <Row style={{textAlign: 'center', paddingTop: 16}}>
              {!orderData.order.finished && orderData.order.orderRessurectionLink && (
                <Button type="primary" href={orderData.order.orderRessurectionLink}>
                  Finish now
                </Button>
              )}
              <Checkbox style={{marginLeft: '10px'}} checked={orderData.order.isTesting} onChange={this.updateIsTestingFlag(updateOrder)}>
                Used for testing
              </Checkbox>
            </Row>
          </div>
        )}
      </Mutation>
    );
  }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/General/General.tsx